import {useEffect, useRef, useState} from "react";


const useExpandCollapseLogic = (stepIndex, activeStepIndex) => {

  // const [transform, setTransform] = useState(0);
  const [expanded, setExpanded] = useState(true);
  const [collapsing, setCollapsing] = useState(false);

  let expandTimeoutId = useRef();

  const collapseRing = () => {
    expandTimeoutId.current = setTimeout(() => {
      setExpanded(false) // make step active
    }, 500)
  }

  const expandRing = () => {
    clearTimeout(expandTimeoutId.current);
    setExpanded(false);
    setCollapsing(true);
    expandTimeoutId.current = setTimeout(() => {
      setExpanded(true);
      setCollapsing(false);
    }, 500)
  }
  // const stepWidth = isMobile ? 68 : 68;

  useEffect(() => {
    // 1) transform
    // let addIndexes = activeStepIndex - stepIndex;
    // if (stepIndex < activeStepIndex) {
    //   addIndexes = addIndexes - 1;
    // }
    // const baseAdd = stepIndex < activeStepIndex ? 92 : 0; // + 92 - is active (scaled) step
    // let transform = baseAdd + (stepWidth * addIndexes);
    // setTransform(transform);

    // 2) collapse/expand
    if (stepIndex === activeStepIndex) {
      collapseRing();
    } else if (stepIndex !== activeStepIndex) {
      expandRing();
    }
    return () => {
      clearTimeout(expandTimeoutId.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStepIndex])

  // const isVisible = wizardActiveStep >= stepIndex;
  // const style = {
  //   transform: `translateX(${transform}px)`
  // }

  return {expanded, collapsing}

};

export default useExpandCollapseLogic
